import type { CurrentNetworkContext, YammerState } from '../../state/types';

type GetNetworkContext = (state: YammerState) => CurrentNetworkContext;
/**
 * @deprecated PERFORMANCE This returns an entity object which can be replaced with a new object instance
 * and force unnecessary re-renders. This should be replaced by a `getNetworkContextField` selector.
 */
export const getNetworkContext: GetNetworkContext = (state: YammerState) => state.session.networkContext;
